export const AdditionalItems = {
    Title: 'Additional Items Found',
    SubHeader: 'The provider found additional items that were not part of the original job description.',
    Titles: {
        ItemPictures: 'Item Pictures',
        AdditionalPayment: 'Additional Payment'
    },
    Buttons: {
        Decline: {
            label: 'Decline'
        },
        Accept: {
            label: 'Accept'
        }
    },
    Text: {
        AdditionalPaymentRequest: 'Additional payment request:',
        OriginalPrice: 'Original Price',
        AdjustedPrice: 'Adjusted Price',
        Total: 'Total:'
    }
}



// WEBPACK FOOTER //
// ./src/localization/AdditionalItems.ts